import { createSlice } from '@reduxjs/toolkit';

interface msgState {
  message: string;
  type: string;
  duration: number;
}
export const initialState: msgState = {
  message: '',
  type: '', // 'info','success','error'
  duration: 3000,
};

export const messageStore = createSlice({
  name: 'message',
  initialState,
  reducers: {
    setMessage(state, action) {
      const { message, type, duration } = action.payload;
      state.message = message;
      state.type = type;
      if (duration) state.duration = duration;
    },
  },
});
